import React from "react";
import { brands } from "../data/mock";

const BrandLogo = ({ name }) => (
  <div className="flex items-center justify-center px-10 shrink-0">
    <span className="text-2xl font-extrabold tracking-tight text-slate-400 hover:text-[#0a1f44] transition-colors whitespace-nowrap" style={{ fontFamily: "Poppins" }}>
      {name}
    </span>
  </div>
);

const Brands = () => {
  const loop = [...brands, ...brands];
  return (
    <section className="section-pad pb-20 sm:pb-24 bg-white overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8 text-center mb-12">
        <span className="eyebrow">80+ Industry-leading brands</span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a1f44] mt-4">
          The <span className="text-[#3b9dff]">brands</span> we work with
        </h2>
        <p className="text-slate-500 mt-3 max-w-2xl mx-auto">
          Our expert installation services ensure that only the highest-quality
          equipment is installed, customized to meet your specific needs.
        </p>
      </div>

      <div className="marquee-pause relative">
        <div className="flex w-max animate-marquee">
          {loop.map((b, i) => (
            <BrandLogo key={`${b}-${i}`} name={b} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
};

export default Brands;
